__turbopack_context__.v({
  "logoBackground": "CarouselStudioBranding-module-scss-module__WJUAlG__logoBackground",
  "logoBackgroundMobile": "CarouselStudioBranding-module-scss-module__WJUAlG__logoBackgroundMobile",
});
